export const siteNav = [
  { label: "热门排行", href: "#ranking" },
  { label: "新番推荐", href: "#new" },
  { label: "题材分类", href: "#genres" },
  { label: "追番指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export const updateTicker = [
  "本站编辑部「本周热度榜」已更新至第 10 位作品",
  "新番推荐区新增 6 部近期高讨论度动画",
  "「追番指南」补充了 TV / 剧场版 / OVA 的区别说明",
  "题材分类新增「美食治愈」与「运动竞技」两个标签",
  "排行榜评分采用本站编辑部综合指数，仅供参考",
];

export const siteStats = [
  { value: "120+", label: "收录作品数量", icon: "ri-film-line" },
  { value: "8", label: "覆盖题材分类", icon: "ri-price-tag-3-line" },
  { value: "10", label: "热门排行席位", icon: "ri-trophy-line" },
  { value: "每周", label: "榜单更新频率", icon: "ri-refresh-line" },
];

export const topAnime = [
  {
    rank: 1,
    title: "葬送的芙莉莲",
    genre: "奇幻冒险",
    tags: ["公路旅行", "魔法", "群像"],
    score: "9.4",
    episodes: "28 话",
    summary:
      "以魔法使芙莉莲的漫长旅途为主线，用温和克制的叙事讨论时间、告别与记忆。节奏舒缓、情绪细腻，非常适合喜欢沉浸式世界观的观众。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20white%20haired%20elf%20mage%20with%20a%20staff%20walking%20through%20a%20sunlit%20fantasy%20meadow%20with%20distant%20mountains%2C%20warm%20cream%20and%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text%2C%20high%20detail&width=600&height=800&seq=anime-rank-01&orientation=portrait",
  },
  {
    rank: 2,
    title: "鬼灭之刃",
    genre: "热血动作",
    tags: ["和风", "战斗", "兄弟情"],
    score: "9.2",
    episodes: "多季连载",
    summary:
      "大正时代背景下的剑士冒险，以精致的作画与刀剑对招场面著称。故事围绕少年为家人复仇、寻找解药的旅程展开，热血与亲情并重。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20young%20swordsman%20holding%20a%20katana%20in%20a%20moonlit%20japanese%20forest%20with%20glowing%20amber%20sparks%2C%20warm%20cream%20and%20crimson%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-02&orientation=portrait",
  },
  {
    rank: 3,
    title: "咒术回战",
    genre: "热血动作",
    tags: ["超自然", "咒术", "校园"],
    score: "9.0",
    episodes: "多季连载",
    summary:
      "少年吞下特级咒物后踏入咒术世界的成长故事。战斗演出凌厉、动作设计密集，世界观在校园与都市之间展开，适合喜爱强节奏打戏的观众。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20hooded%20figure%20surrounded%20by%20swirling%20dark%20supernatural%20energy%20and%20glowing%20amber%20sigils%2C%20mu%20warm%20ochre%20palette%2C%20dramatic%20lighting%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-03&orientation=portrait",
  },
  {
    rank: 4,
    title: "进击的巨人",
    genre: "剧情叙事",
    tags: ["战争", "悬疑", "世界观"],
    score: "8.9",
    episodes: "已完结",
    summary:
      "以高墙之内的生存危机开场，逐步铺陈出宏大的政治与历史谜团。叙事结构层层反转，主题讨论自由、牺牲与选择，适合喜欢厚重剧情的观众。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20colossal%20stone%20wall%20towering%20into%20a%20dramatic%20cloudy%20sky%20with%20tiny%20silhouettes%20below%2C%20mu%20warm%20dusty%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-04&orientation=portrait",
  },
  {
    rank: 5,
    title: "间谍过家家",
    genre: "日常治愈",
    tags: ["喜剧", "家庭", "温情"],
    score: "8.8",
    episodes: "多季连载",
    summary:
      "间谍、杀手与超能力少女组成的「假家庭」，在任务与日常之间闹出层层笑料。轻松治愈、家庭感强，适合下班后放松观看。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20cozy%20warm%20family%20living%20room%20with%20soft%20lamp%20light%20and%20a%20suitcase%20nearby%2C%20warm%20cream%20and%20rose%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-05&orientation=portrait",
  },
  {
    rank: 6,
    title: "孤独摇滚！",
    genre: "日常治愈",
    tags: ["音乐", "校园", "社恐"],
    score: "8.7",
    episodes: "12 话",
    summary:
      "内向少女加入轻音社团后逐渐走出舒适圈的故事。演出形式活泼、玩梗密集，音乐段落与情绪描写结合得相当自然。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20shy%20girl%20holding%20an%20electric%20guitar%20under%20warm%20stage%20lights%20in%20a%20small%20live%20house%2C%20warm%20rose%20and%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-06&orientation=portrait",
  },
  {
    rank: 7,
    title: "链锯人",
    genre: "热血动作",
    tags: ["黑暗", "都市", "异色"],
    score: "8.6",
    episodes: "12 话",
    summary:
      "少年与恶魔契约后成为「链锯人」，在债务与猎魔任务之间挣扎求生。风格粗粝、镜头感强，画面与配乐都带有强烈的电影气质。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20dystopian%20night%20city%20street%20bathed%20in%20deep%20orange%20streetlight%20with%20a%20lone%20silhouette%2C%20warm%20crimson%20and%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-07&orientation=portrait",
  },
  {
    rank: 8,
    title: "赛马娘",
    genre: "运动竞技",
    tags: ["竞技", "成长", "热血"],
    score: "8.5",
    episodes: "多季连载",
    summary:
      "以赛跑竞技为核心的成长群像剧，把比赛过程拍得张力十足。角色目标明确、情绪爆发点密集，是运动题材里少见的稳定高水准作品。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20an%20energetic%20girl%20sprinting%20on%20a%20racetrack%20at%20golden%20hour%20with%20motion%20dust%2C%20warm%20amber%20and%20rose%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-08&orientation=portrait",
  },
  {
    rank: 9,
    title: "我推的孩子",
    genre: "剧情叙事",
    tags: ["偶像", "悬疑", "反转"],
    score: "8.4",
    episodes: "多季连载",
    summary:
      "围绕演艺圈展开的双线叙事，把偶像产业的光鲜与阴影一并摊开。开篇转折强烈、话题度高，适合喜欢讨论度作品的观众。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20bright%20idol%20stage%20with%20warm%20golden%20spotlights%20and%20confetti%2C%20warm%20rose%20and%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-09&orientation=portrait",
  },
  {
    rank: 10,
    title: "死神：千年血战篇",
    genre: "热血动作",
    tags: ["热血", "长篇", "世界观"],
    score: "8.3",
    episodes: "多季连载",
    summary:
      "经典长篇的最终章改编，以升级后的作画还原高密度战斗。老观众能看到情怀落地，新观众也能被华丽的招式演出吸引。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20soul%20reaper%20with%20a%20large%20sword%20standing%20amid%20glowing%20amber%20spiritual%20flames%20and%20dark%20smoke%2C%20warm%20crimson%20and%20gold%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-rank-10&orientation=portrait",
  },
];

export const newSeasonTabs = [
  { id: "all", label: "全部新番" },
  { id: "fantasy", label: "奇幻冒险" },
  { id: "action", label: "热血动作" },
  { id: "slice", label: "日常治愈" },
  { id: "mystery", label: "悬疑剧情" },
  { id: "comedy", label: "搞笑喜剧" },
];

export const newSeasonAnime = [
  {
    title: "迷宫饭",
    category: "fantasy",
    genreLabel: "奇幻冒险",
    schedule: "奇幻 / 美食",
    tags: ["美食", "冒险", "团队"],
    summary:
      "冒险者小队在迷宫里靠「料理魔物」求生，把奇幻探险和美食题材缝在一起。设定严谨、笑点自然，越看越有意思。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20adventurers%20cooking%20a%20hearty%20meal%20over%20a%20campfire%20inside%20a%20stone%20dungeon%2C%20warm%20amber%20and%20cream%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-01&orientation=portrait",
  },
  {
    title: "药师少女的独语",
    category: "mystery",
    genreLabel: "悬疑剧情",
    schedule: "宫廷 / 推理",
    tags: ["推理", "宫廷", "药理"],
    summary:
      "出身药师的少女进入后宫当差，凭嗅觉与药理知识解开一桩桩疑案。单元推理结构清晰，人物关系推进得稳稳当当。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20young%20apothecary%20girl%20in%20elegant%20court%20robes%20holding%20herbs%20in%20a%20lantern%20lit%20palace%20corridor%2C%20warm%20gold%20and%20cream%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-02&orientation=portrait",
  },
  {
    title: "擅长逃跑的殿下",
    category: "action",
    genreLabel: "热血动作",
    schedule: "历史 / 战斗",
    tags: ["历史", "战斗", "成长"],
    summary:
      "以少年武将逃亡与复兴为主线，把历史题材拍出了速度感。动作分镜灵活、色彩明快，兼顾热血与幽默。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20young%20samurai%20leaping%20across%20rooftops%20at%20sunset%20with%20flying%20leaves%2C%20warm%20ochre%20and%20crimson%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-03&orientation=portrait",
  },
  {
    title: "败犬女主太多了！",
    category: "slice",
    genreLabel: "日常治愈",
    schedule: "校园 / 恋爱",
    tags: ["校园", "青春", "群像"],
    summary:
      "以「输掉恋爱」的女生们为切入点的校园日常，对白密集、吐槽活泼。氛围轻松，适合喜欢青春群像的观众。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20high%20school%20students%20chatting%20on%20a%20sunlit%20school%20rooftop%20with%20warm%20afternoon%20light%2C%20warm%20cream%20and%20rose%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-04&orientation=portrait",
  },
  {
    title: "怪兽 8 号",
    category: "action",
    genreLabel: "热血动作",
    schedule: "科幻 / 战斗",
    tags: ["怪兽", "热血", "职场"],
    summary:
      "普通清洁工意外获得怪兽之力，加入防卫队追梦。王道少年漫式展开，战斗作画扎实、节奏明快。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20a%20defense%20force%20squad%20facing%20a%20giant%20monster%20silhouette%20in%20a%20dusty%20ruined%20city%2C%20warm%20amber%20and%20grey%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-05&orientation=portrait",
  },
  {
    title: "胆大党",
    category: "comedy",
    genreLabel: "搞笑喜剧",
    schedule: "灵异 / 搞笑",
    tags: ["灵异", "搞笑", "恋爱"],
    summary:
      "相信幽灵的女孩与相信外星人的男孩打赌，结果两边都超乎预期。画风张扬、笑点密集，是近年来风格最跳脱的喜剧之一。",
    poster:
      "https://readdy.ai/api/search-image?query=Painterly%20anime%20poster%20illustration%20of%20two%20teens%20in%20a%20whimsical%20neon%20lit%20alley%20with%20playful%20floating%20spirits%2C%20warm%20rose%20and%20amber%20palette%2C%20soft%20brush%20texture%2C%20no%20text&width=600&height=800&seq=anime-new-06&orientation=portrait",
  },
];

export const genreList = [
  {
    id: "action",
    name: "热血动作",
    icon: "ri-sword-line",
    count: "收录 32 部",
    brief: "以战斗、成长与对抗为核心，节奏强烈，适合追求爽感与情绪爆发的观众。",
    works: ["鬼灭之刃", "咒术回战", "链锯人", "死神：千年血战篇"],
  },
  {
    id: "fantasy",
    name: "奇幻冒险",
    icon: "ri-magic-line",
    count: "收录 28 部",
    brief: "架空世界观与魔法设定并重，常见公路旅行、工会任务与异世界题材，世界观越大越有沉浸感。",
    works: ["葬送的芙莉莲", "迷宫饭", "约定的梦幻岛"],
  },
  {
    id: "slice",
    name: "日常治愈",
    icon: "ri-cup-line",
    count: "收录 24 部",
    brief: "强调生活感与情绪抚慰，剧情冲突较少，适合睡前或通勤时轻松观看。",
    works: ["孤独摇滚！", "间谍过家家", "夏目友人帐"],
  },
  {
    id: "mystery",
    name: "悬疑剧情",
    icon: "ri-spy-line",
    count: "收录 19 部",
    brief: "以线索铺设和反转推进展开，讲究信息节奏，适合喜欢边看边推理的观众。",
    works: ["药师少女的独语", "我推的孩子", "进击的巨人"],
  },
  {
    id: "romance",
    name: "恋爱青春",
    icon: "ri-heart-line",
    count: "收录 22 部",
    brief: "围绕校园与成长展开的情感故事，情绪细腻，常与日常、喜剧元素混合出现。",
    works: ["败犬女主太多了！", "冰菓", "辉夜大小姐想让我告白"],
  },
  {
    id: "scifi",
    name: "科幻机战",
    icon: "ri-rocket-line",
    count: "收录 15 部",
    brief: "以未来设定、机械设计与人类命题为看点，世界观庞大，常有讨论度较高的哲学议题。",
    works: ["怪兽 8 号", "攻壳机动队", "天元突破"],
  },
  {
    id: "comedy",
    name: "搞笑喜剧",
    icon: "ri-emotion-laugh-line",
    count: "收录 20 部",
    brief: "以玩梗、夸张演出和快速对白取胜，单集独立性强，随时点开都能看。",
    works: ["胆大党", "间谍过家家", "后街女孩"],
  },
  {
    id: "sports",
    name: "运动竞技",
    icon: "ri-run-line",
    count: "收录 12 部",
    brief: "以比赛与团队成长为主线，观感热血，容易带动情绪，适合需要动力的时候观看。",
    works: ["赛马娘", "排球少年", "强风吹拂"],
  },
];

export const genreDefaultNote =
  "点击上方任意题材标签，可查看该分类的定位说明与代表作品。分类仅供参考，不少作品会横跨多个题材。";

export const guideSteps = [
  {
    step: "01",
    title: "先定口味，再挑作品",
    desc: "从自己偏好的情绪出发：想爽快就选热血动作，想放松就看日常治愈，想烧脑则挑悬疑剧情。先锁定题材，再在榜单里挑选，比盲目跟风高效得多。",
  },
  {
    step: "02",
    title: "看前三话再决定是否追",
    desc: "大多数作品会在前三话交代世界观与主角动机。看完三话仍提不起兴趣，果断放弃也是一种追番效率，不必强迫自己补完。",
  },
  {
    step: "03",
    title: "分清新番、老番与完结番",
    desc: "新番指当期正在播出的作品，每周更新；老番是已完结、可一口气看完的库存；完结番适合补剧。时间紧就优先补完结番，避免被更新节奏牵着走。",
  },
  {
    step: "04",
    title: "认识常见分类术语",
    desc: "TV 动画按季度放送，一季通常 12 至 13 话；OVA 与 OAD 多为随原作发售的附加剧集；剧场版是独立院线电影，作画预算往往更高。",
  },
  {
    step: "05",
    title: "建立自己的追番清单",
    desc: "把「在追」「待补」「弃番」分成三档，每周固定一个时间处理更新。清单化之后，既能避免漏番，也不会因为堆太多而失去追剧乐趣。",
  },
];

export const faqList = [
  {
    q: "「新番」到底是什么意思？",
    a: "新番一般指当期正在播出的电视动画，通常按季度划分，一季三个月。它们在开播后每周更新一话，观众边看边等，这种状态就是常说的「追番」。",
  },
  {
    q: "一季、一话、一集有什么区别？",
    a: "「一话」和「一集」通常指同一件事，即一集时长的内容；「一季」指一段连续放送周期，多数为 12 至 13 话，也有 24 至 26 话的长季。",
  },
  {
    q: "OVA、OAD 和剧场版有什么不同？",
    a: "OVA 与 OAD 通常不通过电视台播出，而是随原作或单独发售；剧场版则是独立在影院上映的电影版本，篇幅与制作规格往往更高。",
  },
  {
    q: "本站排行榜依据是什么？",
    a: "排行榜由本站编辑部综合近期讨论热度、观众口碑与作品完成度整理，评分标注为「编辑评分」，属于主观参考值，不代表任何官方数据。",
  },
  {
    q: "在哪里可以观看到这些动画？",
    a: "请通过持有正版授权的平台观看。不同作品的上架地区与平台各不相同，追番前建议先确认所在地区可用的正版渠道。",
  },
  {
    q: "新手应该从哪一部开始入坑？",
    a: "可以先用「日常治愈」或「搞笑喜剧」类作品热身，单集独立、压力小；适应之后再看「奇幻冒险」与「剧情叙事」这类需要连续投入的长线作品。",
  },
];